import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import FullCoverageWarrantyWrapper from "@components/layouts/fullCoverageWarrantyWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function FullCoverageWarrantyHome(): ReactElement {
    return (
        <FullCoverageWarrantyWrapper headerBoxShadow="0px -2px 10px #888888">
            <TermsAndConditions
                category="Warranty"
                domain="FullCoverageWarranty.com"
            />
        </FullCoverageWarrantyWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
